// extracted by mini-css-extract-plugin
export default {"item":"savedContact_item__nYsP6","icon":"savedContact_icon__IzOhZ","itemText":"savedContact_itemText__tWo5Y","btn":"savedContact_btn__IST1P"};